import React from 'react';
import { Route, Routes } from 'react-router';
import { PagePath } from '../navigation.enums';
import { ActiveCompanySlugRedirect } from './routers.helpers';
import { useCompanySlugParamChange } from '../../library/hooks/useCompanySlugParamChange';
import { ContextsPage } from '../../pages/ai-management/contexts/contexts.page';
import { ContextPage } from '../../pages/ai-management/contexts/context.page';
import { AgentPage } from '../../pages/ai-management/agents/agent/agent.page';
import { AgentsPage } from '../../pages/ai-management/agents/agents.page';
import { InformationSearchPage } from '../../pages/ai-management/information-search/information-search.page';
import { ChatPage } from '../../pages/ai-management/chat/chat.page';

export function AIManagementRouter(): JSX.Element {
  useCompanySlugParamChange(PagePath.aiManagementBase);

  return (
    <Routes>
      <Route path={PagePath.aiManagementAgents} element={<AgentsPage />} />
      <Route path={PagePath.aiManagementAgent} element={<AgentPage />} />
      <Route path={PagePath.aiManagementContexts} element={<ContextsPage />} />
      <Route path={PagePath.aiManagementContext} element={<ContextPage />} />
      <Route path={PagePath.aiManagementInformationSearch} element={<InformationSearchPage />} />
      <Route path={PagePath.aiManagementChat} element={<ChatPage />} />

      <Route path={PagePath.rootWildcard} element={<ActiveCompanySlugRedirect landingRedirectTo={`${PagePath.aiManagementBase}${PagePath.aiManagementAgents}`} />} />
    </Routes>
  );
}
